module.exports = __webpack_public_path__ + "img/logo-photoshop.3a95ed48.png";